import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { getTsdSupplierListDataByTsdId } from '../tsdSuppliers/mockData'
import { getTsdContactListDataByTsdId } from '../tsdContacts/mockData'
import { requireAuthenticatedUser } from '../../decorators'
import { getTsdListData, getTsdOverviewData } from './mockData'
import type { ITsd } from '~/types/tsd/models'

interface GetTsdsResponse {
  data: ITsd[]
}

async function getTsds(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetTsdsResponse = { data: await getTsdListData() }
  return res(ctx.status(200), ctx.json(responseBody))
}

async function getTsdsOverview_byId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`'Returning overview for tsd "${id}".`)
  return res(ctx.status(200), ctx.json({ data: await getTsdOverviewData(id) }))
}

async function getTsdSuppliers_byId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`'Returning suppliers for tsd "${id}".`)
  return res(
    ctx.status(200),
    ctx.json({ data: await getTsdSupplierListDataByTsdId(id) })
  )
}

async function getTsdContactsByTsdId(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const { id } = req.params
  if (typeof id !== 'string') {
    const responseBody = {
      statusCode: 500,
      message: 'Passed ID is not a string.',
    }
    return res(ctx.status(500), ctx.json(responseBody))
  }
  console.log(`'Returning contacts for supplier "${id}".`)
  const data = await getTsdContactListDataByTsdId(id)
  return res(ctx.status(200), ctx.json({ data }))
}

// post

const postTsd = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getTsdListData)
}

const patchTsd = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getTsdListData)
}

const deleteTsd = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getTsdListData)
}

export const handlers = [
  {
    method: 'get',
    path: '/api/tsds',
    handler: getTsds,
  },
  {
    method: 'get',
    path: '/api/tsds/:id/overview',
    handler: getTsdsOverview_byId,
  },
  {
    method: 'get',
    path: '/api/tsds/:id/suppliers',
    handler: getTsdSuppliers_byId,
  },
  {
    method: 'get',
    path: '/api/tsds/:id/contacts',
    handler: getTsdContactsByTsdId,
  },
  {
    method: 'post',
    path: '/api/tsds',
    handler: postTsd,
  },
  {
    method: 'patch',
    path: '/api/tsds/:id',
    handler: patchTsd,
  },
  {
    method: 'delete',
    path: '/api/tsds/:id',
    handler: deleteTsd,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
